import React from 'react';
import { RichText, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import Icon from '../@shared/icon';
import { TNextStepsFieldsCard, TNextStepsProps } from './types/nextSteps.types';
import { NextStepsModel } from './models/nextSteps.model';
import { EditFrameComponent } from '../@shared/editFrame';
import fields from '../../constants/fields.const';
import { iconSize } from '../../constants/icon.constants';
import RoutableSitecoreLink from '../@shared/routableSitecoreLink';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import { googleClickCtaEvent } from '../../utils/analytics';

const NextSteps = (props: TNextStepsProps) => {
  const isEEactive = props?.sitecoreContext?.pageEditing;

  if (!isEEactive && !props?.rendering?.dataSource) {
    return null;
  }

  const model = new NextStepsModel(props);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <AnalyticsVisibleEvent rendering={props?.rendering} title={model.title?.value} template="Next Steps Footer">
      <section className={'next-steps'} style={{ backgroundColor: model.backgroundColor || '#f4f4f4' }}>
        <ul className={'next-steps-list'}>
          {model.title?.value && (
            <RichText tag="li" className="next-steps-list__item next-steps-list__item--title rich-text" field={model.title} />
          )}
          {model.cards.map((item: TNextStepsFieldsCard) => (
            <li className={'next-steps-list__item'} key={item?.id}>
              {isEEactive ? (
                <RoutableSitecoreLink
                  field={item?.fields?.url}
                  className={'next-steps-list__item-link'}
                  onClick={() => googleClickCtaEvent('Link', item?.fields?.url?.value?.text, model.title?.value)}
                >
                  <div className="next-steps-list__item-link-icon">
                    <EditFrameComponent itemId={item.id} fields={[fields.icon]} sitecoreContext={props?.sitecoreContext}>
                      <Icon iconField={item?.fields?.icon} size={iconSize.dsk} color="primary" />
                    </EditFrameComponent>
                  </div>
                  <p className="next-steps-list__item-link-text">{item?.fields?.url?.value?.text}</p>
                </RoutableSitecoreLink>
              ) : (
                <RoutableSitecoreLink
                  field={item?.fields?.url}
                  className={'next-steps-list__item-link'}
                  onClick={() => googleClickCtaEvent('Link', item?.fields?.url?.value?.text, model.title?.value)}
                >
                  <div className="next-steps-list__item-link-icon">
                    <Icon iconField={item?.fields?.icon} color="primary" size={32} />
                  </div>
                  <p className="next-steps-list__item-link-text">{item?.fields?.url?.value?.text}</p>
                </RoutableSitecoreLink>
              )}
            </li>
          ))}
        </ul>
      </section>
    </AnalyticsVisibleEvent>
  );
};

export default withSitecoreContext()(NextSteps);
